<template>
  <div>
    <div class="column is-narrow add-btn" v-if="isAdmin">
      <button class="button is-primary is-small" @click.prevent="showCreateForm">
        <octicon :icon="plus" />&ensp;{{ $l("global.add", "Add") }}
      </button>
    </div>

    <data-table ref="table" :key="currentLocale" :items="osListFunc" :per-page="20" :sort-desc="true"
      :theme="$_ui_theme_tables">
      <data-column :sortable="false" field="serial" :label="$l('components.configurationUpdate.serial', 'No')"
        width="7%" />
      <data-column field="name" :label="$l('components.configurationUpdate.name', 'Name')">
        <template #default="{ item }">
          <div class="truncate">
            {{ item.name }}
          </div>
        </template>
      </data-column>
      <data-column field="name" label="Group">
        <template #default="{ item }">
          <div class="truncate">
            {{ item.group }}
          </div>
        </template>
      </data-column>
      <data-column :sortable="false" field="description"
        :label="$l('components.configurationUpdate.description', 'Description')">
        <template #default="{ item }">
          <div class="truncate">
            {{ item.description }}
          </div>
        </template>
      </data-column>
      <data-column field="status" :label="$l('components.configurationUpdate.status', 'Status')" :sortable="true">
        <template #header>
          <div class="column-header">
            <span>{{ $l("components.configurationUpdate.type", "Type") }}</span>
            <Dropdown placement="bottom-start" trigger="custom" :visible="filter.filterStatus.isFilterOpen"
              @on-clickoutside="
      handleCloseFilter(filter.filterStatus.filterType)
      ">
              <span href="javascript:void(0)" @click="toggleFilter('filterStatus')" class="icon">
                <svg-icon type="mdi" :path="path" :class="{
      'filter-active': filter.filterStatus.isSubmitFilter,
    }"></svg-icon>
              </span>
              <DropdownMenu slot="list">
                <div class="menu-list">
                  <label v-for="(i, index) in listStatus" :key="index">
                    <DropdownItem>
                      <input type="checkbox" v-model="filter.filterStatus.filterValues" :value="i.value" />

                      <span style="margin-left: 10px">{{
      $l(`components.configurationUpdate.${i.name}`)
    }}</span>
                    </DropdownItem>
                    <div class="divider"></div>
                  </label>

                  <div class="filter-button">
                    <Button type="text" size="small" :disabled="!filter.filterStatus.filterValues.length"
                      @click="submitFilter(filter.filterStatus.filterType)"><span style="font-weight: bold">{{
      $l("global.submit", "Submit")
    }}</span></Button>
                    <Button type="text" size="small" color="#2096f2"
                      @click="resetFilter(filter.filterStatus.filterType)"><span style="font-weight: bold">{{
      $l("global.reset", "Reset")
    }}</span></Button>
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>

        <template #default="{ item }">
          <div class="status-column" :class="{
      'status-active': item.status,
      'status-inactive': !item.status,
    }">
            {{
      item.status
        ? $l("components.configurationUpdate.enabled", "Enabled")
        : $l("components.configurationUpdate.disabled", "Disabled")
    }}
          </div>
        </template>
      </data-column>

      <data-column :sortable="false" width="7%">
        <template v-if="isAdmin" #default="{ item }">
          <div class="actions-column-os">
            <Dropdown trigger="click" placement="bottom-start">
              <span v-if="isRoot" href="javascript:void(0)" style="cursor: pointer">
                <octicon :icon="kebabHorizontal" label="kebabHorizontal" />
              </span>
              <DropdownMenu slot="list">
                <DropdownItem @click.native="showUpdateForm(item)">
                  <span>{{
      $l("components.configurationUpdate.update", "Update")
    }}</span>
                </DropdownItem>

                <div class="divider"></div>

                <DropdownItem @click.native="changeStatus(item)" v-if="!item.status">
                  <span style="color: #2096f2">{{
      $l("components.configurationUpdate.enable", "Enable")
    }}</span>
                </DropdownItem>
                <DropdownItem @click.native="changeStatus(item)" v-if="item.status">
                  <span style="color: red">{{
      $l("components.configurationUpdate.disable", "Disable")
    }}</span>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </template>
      </data-column>
    </data-table>

    <modal :show.sync="formModal.isFormOpen">
      <box>
        <div class="close-icon" @click="formModal.isFormOpen = false">
          <Icon size="25" type="ios-close" />
        </div>
        <div style="text-align: center; font-weight: bold">
          <span>{{
      formModal.type === "create"
        ? $l("components.configurationUpdate.createOS", "Create OS")
        : $l("components.configurationUpdate.updateOS", "Update OS")
    }}</span>
        </div>

        <div style="margin: auto; width: 90%">
          <Form ref="form" :model="form" :rules="ruleValidate" label-position="top">
            <FormItem ref="name" prop="name">
              <template slot="label">
                <strong>{{ $l("components.configurationUpdate.name", "Name") }}</strong>
              </template>

              <Input v-model="form.name" :placeholder="$l('components.configurationUpdate.enterName', 'Enter name')
      " />
            </FormItem>

            <FormItem ref="description" prop="description">
              <template slot="label">
                <strong>{{
      $l(
        "components.configurationUpdate.description",
        "Description"
      )
    }}</strong>
              </template>

              <Input v-model="form.description" type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" :placeholder="$l('components.configurationUpdate.description', 'Description'
    )" />

            </FormItem>
            <FormItem ref="group" prop="group">
              <template slot="label">
                <strong>Group</strong>
              </template>
              <!-- <Input v-model="form.group" placeholder="Group" /> -->
              <Select v-model="form.group" placeholder="Group">
                <Option v-for="item in listOsGroup" :value="item.value" :key="item.value">{{ item.name }}</Option>
              </Select>

            </FormItem>
            <FormItem v-if="formModal.type === 'update'" ref="status" prop="status">
              <template slot="label">
                <strong>{{
      $l("components.configurationUpdate.name", "Name")
    }}</strong>
              </template>
              <switches v-model="form.status" type-bold="false" theme="custom" color="blue"
                :class="{ disabled: form.isDefault }"></switches>
              <span style="position: relative; top: -16px; left: 5px">{{
      $l("components.configurationUpdate.active", "Activated")
                }}</span>
            </FormItem>

            <FormItem>
              <div class="field is-grouped is-grouped-right">
                <div class="control">
                  <Button style="margin-right: 8px" @click="formModal.isFormOpen = false">{{ $l("global.cancel",
                    "Cancel")
                    }}</Button>
                </div>
                <div class="control">
                  <Button v-if="formModal.type === 'create'" type="primary" @click="handleClickCreate">
                    {{ $l("global.complete", "Compelete") }}</Button>

                  <Button v-if="formModal.type === 'update'" type="primary" @click="handleClickUpdate">
                    {{ $l("global.complete", "Complete") }}</Button>
                </div>
              </div>
            </FormItem>
          </Form>
        </div>
      </box>
    </modal>

    <!-- <modal :show.sync="deleteConfirmation.isFormOpen" content-width="40%">
      <box>
        <div slot="header">
          {{
            $l(
              "components.configurationUpdate.deleteOSConfirm",
              "Delete OS confirm"
            )
          }}
        </div>
        <div style="margin: auto; width: 90%">
          <div
            class="field mt-5"
            style="background-color: #dfa9a9; padding: 15px"
          >
            <div style="color: #a40303">
              {{
                $l(
                  "components.configurationUpdate.warning",
                  "Attention! This action cannot be undone"
                )
              }}
            </div>
          </div>

          <div class="field is-grouped is-grouped-right mt-5">
            <div class="control">
              <button
                class="button is-light"
                @click.prevent="deleteConfirmation.isFormOpen = false"
              >
                {{ $l("global.close", "Close") }}
              </button>
            </div>
            <div class="control">
              <button
                class="button is-danger"
                @click.prevent="deleteOS(deleteConfirmation.item)"
              >
                {{ $l("global.delete", "Delete") }}
              </button>
            </div>
          </div>
        </div>
      </box>
    </modal> -->
  </div>
</template>

<script>
import UpdateApi from "@/api/Update";
import { plus, kebabHorizontal, cloudUpload } from "octicons-vue";
import { Tabs, Tab, DataTable, DataColumn, Modal } from "@cyradar/ui";
import SvgIcon from "@jamescoyle/vue-icon";
import vSelect from "vue-select";
import Switches from "vue-switches";

import { mapGetters } from "vuex";

import { mdiFilter } from "@mdi/js";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Checkbox,
  Table,
  Page,
  Select,
  Button,
  Form,
  FormItem,
  Input,
  Icon,
  Option
} from "iview";

export default {
  components: {
    Tabs,
    Tab,
    DataTable,
    DataColumn,
    Modal,
    SvgIcon,
    vSelect,
    Switches,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Checkbox,
    Table,
    Page,
    Button,
    Form,
    FormItem,
    Input,
    Icon,
    Select,
    Option
  },
  data() {
    return {
      path: mdiFilter,
      cloudUpload,
      plus,
      kebabHorizontal,
      form: {},
      formModal: {
        isFormOpen: false,
        type: "",
      },
      listStatus: [
        {
          value: true,
          name: "enabled",
        },
        {
          value: false,
          name: "disabled",
        },
      ],
      listOsGroup: [],
      filter: {
        filterStatus: {
          filterType: "status",
          isFilterOpen: false,
          isSubmitFilter: false,
          filterValues: [],
        },
      },

      deleteConfirmation: {
        isFormOpen: false,
      },

      isRoot: null,
    };
  },
  computed: {
    ...mapGetters(["isAdmin", "currentLocale"]),

    defaultRule() {
      return {
        required: true,
        message: this.$l(
          "components.configurationUpdate.cannotBeLeftBlank",
          "Cannot be left blank"
        ),
        trigger: "blur",
      };
    },

    ruleValidate() {
      return {
        name: [
          this.defaultRule,
          {
            type: "string",
            validator: this.checkValidName,
            required: true,
            trigger: "blur",
          },
        ],
      };
    },
  },
  methods: {
    // Check valid

    checkValidName(rule, value, callback) {
      if (value.length < 3 || value.length > 256) {
        callback(
          new Error(
            this.$l(
              "components.configurationUpdate.nameValidLength",
              "Name must have a length ranging from 3 to 256 characters"
            )
          )
        );
      } else {
        const regex = /^[a-zA-Z0-9_.-]+$/;
        if (!regex.test(value)) {
          callback(
            new Error(
              this.$l(
                "components.configurationUpdate.nameValidFormat",
                "Name cannot contain spaces and can only include alphanumeric characters, dots (.), or underscores (_)"
              )
            )
          );
        } else {
          callback();
        }
      }
    },

    // Filter

    toggleFilter(type) {
      event.stopPropagation();
      Object.keys(this.filter).forEach((key) => {
        if (key !== type) {
          this.filter[key].isFilterOpen = false;
        }
      });

      this.filter[type].isFilterOpen = !this.filter[type].isFilterOpen;
    },

    handleCloseFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        if (!this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.filterValues = [];
        }

        this.filter.filterStatus.isFilterOpen = false;
      }
    },

    submitFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;

        if (this.filter.filterStatus.filterValues.length === 0) {
          this.filter.filterStatus.isSubmitFilter = false;
        } else {
          this.filter.filterStatus.isSubmitFilter = true;
          this.$refs.table.loadItems();
        }
      }
    },

    resetFilter(filterType) {
      if (filterType === this.filter.filterStatus.filterType) {
        this.filter.filterStatus.isFilterOpen = false;
        this.filter.filterStatus.filterValues = [];

        if (this.filter.filterStatus.isSubmitFilter) {
          this.filter.filterStatus.isSubmitFilter = false;
          this.$refs.table.loadItems();
        }
      }
    },

    // Get OS table

    osListFunc(filtering, sorting, paging) {
      const params = {
        status: this.filter.filterStatus.isSubmitFilter
          ? this.filter.filterStatus.filterValues.join(",")
          : "",
      };
      return UpdateApi.getOSVueTable(
        this.$http,
        filtering,
        sorting,
        paging,
        params
      ).then(function (res) {
        const dataLength = res.data.items.length;
        for (let i = 0; i < dataLength; i++) {
          res.data.items[i].serial = (paging.page - 1) * paging.perPage + i + 1;
        }
        return res.data;
      });
    },

    // Delete OS

    // showDeleteConfirmation(item) {
    //   this.deleteConfirmation.isFormOpen = true;
    //   this.deleteConfirmation.item = item;
    // },

    // deleteOS(item) {
    //   UpdateApi.deleteOS(this.$http, item._id).then((res) => {
    //     this.$store.dispatch("NOTIFY", {
    //       type: "success",
    //       text: res.message,
    //       duration: 10000,
    //     });
    //     this.deleteConfirmation.isFormOpen = false;
    //     this.$refs.table.loadItems();
    //   });
    // },

    // Update OS - change status

    showUpdateForm(item) {
      this.formModal.isFormOpen = true;
      this.formModal.type = "update";
      this.form = {
        _id: item._id,
        name: item.name,
        description: item.description,
        status: item.status,
        group: item.group,
      };

      this.$refs["form"].resetFields();
    },

    updateOS() {
      UpdateApi.updateOS(this.$http, this.form).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.$refs.table.loadItems();
        this.formModal.isFormOpen = false;
      });
    },

    changeStatus(item) {
      this.form = {
        _id: item._id,
        name: item.name,
        description: item.description,
        group: item.group,
        status: item.status ? false : true,
      };
      this.updateOS();
      this.form = {};
    },

    // Create OS

    showCreateForm() {
      this.formModal.isFormOpen = true;
      this.formModal.type = "create";
      this.form = {};

      this.$refs["form"].resetFields();
    },
    async fetchOsGroup() {
      console.log("fetchOsGroupfetchOsGroupfetchOsGroup")
      await UpdateApi.getOSGroup(this.$http).then((data) => {
        let tags = data;
        this.listOsGroup = tags.map((tag) => {
          return { name: tag.description, value: tag.name };
        });

        console.log("this.listOsGroup", this.listOsGroup)
      });
    },
    saveOS() {
      UpdateApi.addOS(this.$http, this.form).then((res) => {
        this.$store.dispatch("NOTIFY", {
          type: "success",
          text: res.message,
          duration: 10000,
        });
        this.$refs.table.loadItems();
        this.formModal.isFormOpen = false;
      });
    },

    // Handle Click

    handleClickCreate() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.saveOS();
        }
      });
    },

    handleClickUpdate() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.updateOS();
        }
      });
    },

    // Check is root
    async checkIsRoot() {
      await UpdateApi.checkIsRoot(this.$http).then((res) => {
        if (res.data && res.data.product === "root") {
          this.isRoot = true;
        }
      });
    },
  },
  // create() {
  //   this.fetchOsGroup();
  // },
  mounted() {
    this.checkIsRoot();
    this.fetchOsGroup();
  },
};
</script>
<!-- <style src="vue-select/dist/vue-select.css"></style> -->
<style lang="scss" scoped>
@import "assets/app.scss";

.actions-column-os {
  display: flex;
  justify-content: center;

  .menu-button:hover {
    opacity: 0.5;
    cursor: pointer;
  }
}

.menu-list {
  max-height: 200px;
  overflow: scroll;
}

.close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;

  &:hover {
    opacity: 0.5;
  }
}

/deep/ button.modal-close {
  display: none;
}

.filter {
  z-index: 2;
  position: relative;
  cursor: pointer;
  font-weight: bold;
  left: 89.5%;
  top: 67px;
  width: 10px;

  .icon {
    .filter-active {
      color: #2096f2 !important;
    }
  }
}
</style>
